import { FinancialDocumentExtended } from "@common/types/financialDocument";

export enum AccrualImporterSort {
    FILE_NAME_ASC = "FILE_NAME_ASC",
    FILE_NAME_DESC = "FILE_NAME_DESC",
    STATUS_ASC = "STATUS_ASC",
    STATUS_DESC = "STATUS_DESC",
}

export interface AccrualImporterDocumentRow {
    id: string;
    file?: File;
    financialDocument?: FinancialDocumentExtended;
}

export interface AccrualImporterViewRow {
    id: string;
    documentRowId?: string;
    rowNumber: number;
    file?: File;
    financialDocument?: FinancialDocumentExtended;
    extractionId?: string;
    lineItemId?: string;
    groupLabel?: string;
    isPlaceholder?: boolean;
}
